import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import Cookies from "universal-cookie";
import "../../commoncss/Common.css";
import { MdCancel } from "react-icons/md";
import Loader from "../../commoncomponents/Loader";
import { useToast } from "../../commoncomponents/ToastProvider";

export const data = [
  ["Year", "Sales", "Expenses", "Profit"],
  ["2014", 1000, 400, 200],
  ["2015", 1170, 460, 250],
  ["2016", 660, 1120, 300],
  ["2017", 1030, 540, 350],
];

export const options = {
  chart: {
    title: "Company Performance",
    subtitle: "Sales, Expenses, and Profit: 2014-2017",
  },
};
const Agentdata = () => {
  const [getData, setData] = useState({});
  const [getLead, setLead] = useState([{}]);
  const [getLeadlist, setLeadlist] = useState([{}]);
  const [getTicket, setTicket] = useState("");
  const [getViewpopuplead, setViewpopuplead] = useState("");
  const [getViewpopupedit, setViewpopupedit] = useState("");
  const cookie = new Cookies();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const [getSelLeadData, setSelLeadData] = useState({});

  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 20,
    page: 0,
  });

  const [getTotalCount, setTotalCount] = useState(0);

  const create_data = async () => {
    setLoading(true);
    try {
      // props.setLoading('loading')
      const resp = await fetch(`${process.env.REACT_APP_URL}/agent/newdata`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("agent"),
          ...getData,
          amount: 0,
        }),
      });
      const dataset = await resp.json();
      console.log(dataset);
      if (resp.status === 200) {
        if (dataset.status === true) {
          showToast("Entry created successfully", "success");
        } else {
          showToast(dataset.err.msg, "Failed to create entry", "error");
        }
      } else {
        showToast(
          `Request error occured while creating entry ${resp.status}`,
          "error"
        );
      }
    } catch (error) {
      console.log("Failed to create entry for agent data", error);
      showToast("Network error occured, please try later", "error");
    } finally {
      setLoading(false);
    }
  };

  const get_data = async () => {
    setLoading(true);
    try {
      const resp = await fetch(`${process.env.REACT_APP_URL}/agent/data`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("agent"),
          ticket: getTicket,
          skip:
            paginationModel.page != 0
              ? paginationModel.page * paginationModel.pageSize
              : paginationModel.page,
          count: paginationModel.pageSize,
        }),
      });
      const dataset = await resp.json();
      console.log(dataset);
      if (resp.status === 200) {
        if (dataset.status === true) {
          setLead(dataset.data.data);
          setLeadlist(dataset.data.data);
          setTotalCount(dataset.data.count);
        } else {
          showToast("Failed to fetch data, try again", "error");
        }
      } else {
        showToast(
          `Request error occured  while fetching data${resp.status}`,
          "error"
        );
      }
    } catch (error) {
      console.log("Failed to create entry for agent data", error);
      showToast("Network error occured, please try later", "error");
    } finally {
      setLoading(false);
    }
  };

  const update_data = async () => {
    try {
      setLoading(true);
      if (document.getElementById("updateremark").value !== "") {
        console.log(getViewpopuplead, "here it is");
        const resp = await fetch(
          `${process.env.REACT_APP_URL}/agent/updatedata`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify({
              ticket: getViewpopuplead,
              token: cookie.get("agent"),
              updatelead: {
                // amount: document.getElementById("updateamount").value * 100,
                amount: 0,
                remark: document.getElementById("updateremark").value,
              },
            }),
          }
        );
        if (resp.status === 200) {
          const dataset = await resp.json();
          if (dataset.status === true) {
            showToast("Updated data successfully", "success");
            setViewpopuplead("");
            get_data();
          } else {
            showToast("Failed to update data, try again", "error");
          }
        } else {
          showToast(
            `Request error occured  while updating data${resp.status}`,
            "error"
          );
        }
      } else {
        showToast("Enter Data in remark", "error");
      }
    } catch (error) {
      console.log("Failed to update data for agent data", error);
      showToast("Network error occured, please try later", "error");
    } finally {
      setLoading(false);
    }
  };

  const clear_remark = async () => {
    try {
      // props.setLoading('loading')
      if (document.getElementById("updateremark").value !== "") {
        console.log(getViewpopuplead, "here it is");
        const resp = await fetch(
          `${process.env.REACT_APP_URL}/agent/clear_remark`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify({
              ticket: getViewpopuplead,
              token: cookie.get("agent"),
              updatelead: {
                // amount: document.getElementById("updateamount").value * 100,
                amount: 0,
                remark: document.getElementById("updateremark").value,
              },
            }),
          }
        );
        if (resp.status === 200) {
          const dataset = await resp.json();
          if (dataset.status === true) {
            // props.setLoading('success')
            setViewpopuplead("");
            get_data();
          } else {
            // props.setLoading('fail')
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const update_username = async () => {
    try {
      setLoading(true);
      if (document.getElementById("updateusername").value !== "") {
        console.log(getViewpopupedit, "here it is");
        const resp = await fetch(
          `${process.env.REACT_APP_URL}/agent/updateusername`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify({
              ticket: getViewpopupedit,
              token: cookie.get("agent"),
              update_name: document.getElementById("updateusername").value,
            }),
          }
        );
        if (resp.status === 200) {
          const dataset = await resp.json();
          if (dataset.status === true) {
            showToast("Update username successfully", "success");
            setViewpopupedit("");
            get_data();
          } else {
            showToast("Failed to update username", "error");
          }
        } else {
          showToast(
            `Request error occured  while fetching data ${resp.status}`,
            "error"
          );
        }
      } else {
        showToast("Please enter username", "error");
      }
    } catch (error) {
      console.log("Failed  to update username for agent data", error);
      showToast("Network error occured, please try later", "error");
    } finally {
      setLoading(false);
    }
  };

  const PopupLead = () => {
    if (getViewpopuplead !== "") {
      let long_remark = "";
      for (let i = 0; i < getSelLeadData.data.length; i++) {
        long_remark += getSelLeadData.data[i].remark;
        if (getSelLeadData.data[i].length > 0) {
          long_remark += " ";
        }
      }
      console.log(long_remark);
      return (
        <>
          <div
            className="parentPopup"
            onClick={(e) => {
              setViewpopuplead("");
            }}
          ></div>
          <div className="childPopup">
            <div className="cancel_icon_container">
              <MdCancel
                className="cancel_icon"
                onClick={() => setViewpopuplead("")}
              />
            </div>
            <table>
              <tr>
                <td>Name : </td>
                <td>{getLead[0].name}</td>
              </tr>
              <tr>
                <td>Phone Number : </td>
                <td>{getLead[0].phone}</td>
              </tr>
              {/* <tr>
								<td>Amount</td>
								<td>
									<input
										id="updateamount"
										type="text"
										name="amount"
										placeholder="Enter Amount here"
									/>
								</td>
							</tr> */}
              <tr>
                <td>Remark</td>
                <td>
                  <textarea
                    style={{
                      width: "259px",
                      height: "300px",
                      marginLeft: "1px",
                    }}
                    id="updateremark"
                    type="text"
                    name="remark"
                    placeholder="Enter Remark here"
                    defaultValue={long_remark}
                  />
                </td>
              </tr>
            </table>
            <div
              className="btn_container"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                margin: "10px 0px",
              }}
            >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  update_data();
                }}
              >
                {loading ? <Loader loading={loading} /> : "Submit"}
              </button>
            </div>
          </div>
        </>
      );
    }
  };

  const PopupEdit = () => {
    if (getViewpopupedit !== "") {
      return (
        <>
          <div
            className="parentPopup"
            onClick={(e) => {
              setViewpopupedit("");
            }}
          ></div>
          <div className="childPopup">
            <div className="cancel_icon_container">
              <MdCancel
                className="cancel_icon"
                onClick={() => setViewpopupedit("")}
              />
            </div>
            <table>
              <tr>
                <td>Name : </td>
                <td>{getLead[0].name}</td>
              </tr>
              <tr>
                <td>Phone Number : </td>
                <td>{getLead[0].phone}</td>
              </tr>
              <tr>
                <td>New Username:</td>
                <td>
                  <input
                    id="updateusername"
                    type="text"
                    name="username"
                    placeholder="Enter New Username here"
                  />
                </td>
              </tr>
            </table>
            <div
              className="btn_container"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                margin: "10px 0px",
              }}
            >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  update_username();
                }}
              >
                {loading ? <Loader loading={loading} /> : "Submit"}
              </button>
            </div>
          </div>
        </>
      );
    }
  };

  useEffect(() => {
    get_data();
    // get_transaction_list()
  }, [paginationModel]);

  useEffect(() => {
    get_data();
  }, [""]);

  return (
    <>
      <PopupLead />
      <PopupEdit />
      <div className="agent_wrapper">
        <div className="top_search_fields">
        <div className="fields_row">
          <div className="fields_item">
            <label>Username</label>
            <input
              type="text"
              name="name"
              placeholder="Enter Username"
              onChange={(e) => {
                setData({
                  ...getData,
                  [e.target.name]: e.target.value,
                });
              }}
            />
          </div>
          <div className="fields_item">
            <label>Remark</label>
            <input
              type="text"
              name="remark"
              placeholder="Enter Remark"
              onChange={(e) => {
                setData({
                  ...getData,
                  [e.target.name]: e.target.value,
                });
              }}
            />
          </div>
          <div className="fields_item">
            <label>Phone</label>
            <input
              type="text"
              name="phone"
              placeholder="Enter phone"
              onChange={(e) => {
                setData({
                  ...getData,
                  [e.target.name]: e.target.value,
                });
              }}
            />
          </div>
        </div>
        <div className="btn_container">
          <button
            onClick={(e) => {
              e.preventDefault();
              create_data();
            }}
          >
            {loading ? <Loader loading={loading} /> : "Save Entry"}
          </button>
        </div>
      </div>

      <div className="top_search_fields">
        <div
          className="options_table"
          style={{
            marginTop: "40px",
            display: "flex",
            justifyContent: "Center",
            marginTop: "5px",
          }}
        >
          <tr>
            <td>
              <input
                onChange={(e) => {
                  setTicket(e.target.value);
                }}
                type="text"
                placeholder="Username or Phone no"
              />
            </td>
            <td>
              <div className="btn_container">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    get_data();
                  }}
                >
                  {loading ? <Loader loading={loading} /> : "Search"}
                </button>
              </div>
            </td>
          </tr>
        </div>
        <div style={{ textAlign: "right" }}>
          <select
            defaultValue={paginationModel.pageSize}
            onChange={(e) => {
              setPaginationModel({
                ...paginationModel,
                pageSize: e.target.value,
              });
            }}
          >
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>

      <div className="table_container">
        <table>
          <tr>
            <th>Sr. No.</th>
            <th>Ticket No.</th>
            <th>UserName</th>
            <th>Phone</th>
            {/* <th>Amount</th> */}
            {/* <th>Ticket ID</th> */}
            {/* <th>Entry By</th> */}
            <th style={{ maxWidth: "600px", overflowWrap: "break-word" }}>
              Remark
            </th>
            <th>Create Time</th>
            <th>Add Lead</th>
            <th>Edit</th>
          </tr>
          {getLead.map((e, index) => {
            if (Object.keys(e).length == 0) {
              return <tr></tr>;
            } else {
              return (
                <tr>
                  <td style={{ fontWeight: 500, textDecoration: "underline" }}>
                    {index + 1}
                  </td>
                  <td>{e.ticket_no}</td>
                  <td>{e.name}</td>
                  <td>{e.phone}</td>
                  {/* <td>₹{(e.amount / 100).toLocaleString("en-IN")}</td> */}
                  {/* <td>{e.ticket}</td> */}
                  {/* <td>{e.data[e.data.length - 1].entry_name}</td> */}
                  {/* <td>{e.data[e.data.length - 1].remark}</td> */}
                  <td style={{ maxWidth: "600px", overflowWrap: "break-word" }}>
                    {e.data.map((ee, index) => {
                      return `${ee.remark} `;
                    })}
                  </td>
                  <td>
                    {new Date(
                      e.data[e.data.length - 1].updated_time
                    ).toLocaleString()}
                  </td>
                  <td>
                    <div className="btn_container">
                      <button
                        className="table_btn"
                        onClick={(ee) => {
                          setSelLeadData(e);
                          ee.preventDefault();
                          setViewpopuplead(e.ticket);
                        }}
                      >
                        Follow Up
                      </button>
                    </div>
                  </td>
                  <td
                    onClick={(f) => {
                      setViewpopupedit(e.ticket);
                    }}
                    style={{ fontSize: "23px", color: "#4b49ac" }}
                  >
                    <FaEdit />
                  </td>
                </tr>
              );
            }
          })}
        </table>
        <div className="btn_container">
          {paginationModel.page > 0 ? (
            <button
              className="table_btn"
              onClick={(e) => {
                console.log(paginationModel);
                setPaginationModel({
                  ...paginationModel,
                  page: paginationModel.page - 1,
                });
              }}
            >
              Back
            </button>
          ) : (
            <></>
          )}

          {getTotalCount / paginationModel.pageSize >= 1 ? (
            <button className="table_btn">
              {paginationModel.page + 1} of{" "}
              {Math.round(getTotalCount / paginationModel.pageSize)}
            </button>
          ) : (
            <button className="table_btn">{1}</button>
          )}

          {paginationModel.page + 1 <
          getTotalCount / paginationModel.pageSize ? (
            <button
              className="table_btn"
              onClick={(e) => {
                console.log(paginationModel);
                setPaginationModel({
                  ...paginationModel,
                  page: paginationModel.page + 1,
                });
              }}
            >
              Next
            </button>
          ) : (
            <></>
          )}
        </div>
        </div>
      </div>
    </>
  );
};

export default Agentdata;
